import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LoadingComponent from '../../layout/LoadingComponent';

function RedirectPage() {
    const { token } = useParams(); // Extract token from the URL
    const navigate = useNavigate(); // Hook for navigation

    useEffect(() => {
        // Runs once on mount
        if (token) {
            debugger;
            localStorage.setItem('user', token.replace(/~/g, '.'));
            localStorage.setItem('displayName', '');
            navigate('/'); // Navigate to home page
        }
    }, [token, navigate]);

    return <LoadingComponent />;
}

export default RedirectPage;
